var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7715 6.7287C21.1975 7.15473 21.1975 7.84545 20.7715 8.27148L9.77148 19.2715C9.56689 19.4761 9.28942 19.591 9.00009 19.591C8.71076 19.591 8.43328 19.4761 8.2287 19.2715L3.2287 14.2715C2.80267 13.8455 2.80267 13.1547 3.2287 12.7287C3.65473 12.3027 4.34545 12.3027 4.77148 12.7287L9.00009 16.9573L19.2287 6.7287C19.6547 6.30267 20.3455 6.30267 20.7715 6.7287Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBig);
export default __webpack_public_path__ + "static/media/checkBig.beeccce200124d5e961665adb228781d.svg";
export { ForwardRef as ReactComponent };